<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17PXHMS/tc-custom/9781504031103.jpg?1727650173451" alt="This image is the cover for the book Unforgotten"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unforgotten
      </h1>
      <p class="bookDescription body article font2">
        <b>A courtroom drama of deceit and family secrets set in the heart of London from international bestselling author Clare Francis</b><br/><br/> Lawyer Hugh Gwynne is in the throes of his most difficult court case yet: His client Tom Deacon was in a car accident in which he witnessed the death of his young daughter . . .  <br/>  <br/> Since the crash, Deacon claims to be suffering from trauma and flashbacks, and the case seems poised for victory as a result of Deacon’s PTSD. But when an anonymous letter arrives for Gwynne, the case takes an unexpected turn that will force the lawyer to make his most difficult decision yet. Thus far, Gwynne has had what he considers a noble and idyllic life, replete with a golden wife and two adopted children. In one night, could everything come crashing down?<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clare Francis
      </h2>
      
      <p class="authorDescription body article">Clare Francis (b. 1946) is a bestselling writer of crime novels and thrillers, and a former yachtswoman. After studying at the Royal Ballet School and University College London, she set off on an unplanned five-year career in sailing. Francis sailed solo across the Atlantic, and took part in several high-profile races, including the Whitbread Round the World Race. After writing three works of nonfiction about her adventures, she started writing novels. Her first novel, <I>Night Sky</I>, was a number one <I>Sunday Times</I> bestseller and spent six weeks on the <I>New York Times</I> bestseller list. More thrillers followed, and her first crime novel, <I>Deceit</I>, was dramatized for television. Since then she has written crime, suspense, and historical literary fiction. Her books have been translated into twenty languages and published in over thirty countries. Francis is a Member of the Most Excellent Order of the British Empire, a Fellow of University College London, and an Honorary Fellow of the University of Manchester Institute of Science and Technology. For the past eighteen years she has been committed to the charity Action for ME, and she herself has had ME (also known as post viral fatigue syndrome, or chronic fatigue syndrome) for many years. Francis lives in London and the Isle of Wight.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56d03f94